enum CATEGORIES_CONSTANTS {
    GET_CATEGORIES_BEGIN = "GET_CATEGORIES_BEGIN",
    GET_CATEGORIES_ERROR = "GET_CATEGORIES_ERROR",
    GET_CATEGORIES_SUCCESS = "GET_CATEGORIES_SUCCESS",

    SAVE_CATEGORY_FILTER = "SAVE_CATEGORY_FILTER"
};

export default CATEGORIES_CONSTANTS;